import React, {Component} from 'react';
import PrintBNPDoc from './PrintBNPDoc';

class PrintBNPInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintBNPDoc
        title={'ใบแจ้งหนี้'} 
        doc={'invoice_doc'}
        docNo={this.props.ivNo}
        param={'iv'}
      >
      </PrintBNPDoc>
    )
  }
}  

export default PrintBNPInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/bnp/PrintBNPInvoiceDoc.js